import { MDCRipple } from '@material/ripple';

const Ripple = (() => {
  const config = {
    get triggers() {
      return this.triggerCN
        .map(CN => [...document.querySelectorAll(`.${CN}`)])
        .reduce((acc, current) => [...acc, ...current]);
    },
    triggerCN: ['button'],
  };

  const build = () => {
    config.triggers.forEach(trigger => MDCRipple.attachTo(trigger));
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export const queueRipple = () =>
  setTimeout(() => {
    Ripple.init();
  }, 100);

export default Ripple.init();
